// Lazy load
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expand = 10;
window.lazySizesConfig.lazyClass = 'js-lazy-load';
lazySizesConfig.expFactor = 1.5;
lazySizesConfig.srcAttr = 'data-original';
lazySizesConfig.loadMode = 1;